'use client';

import React from 'react';

interface Props {
  suggestions: string[];
  onSelect: (text: string) => void;
}

export default function SuggestedReplies({ suggestions, onSelect }: Props) {
  return (
    <div className="px-3 pb-2 overflow-x-auto scrollbar-hide fade-in">
      <div className="flex gap-2 max-w-lg mx-auto">
        {suggestions.map((s) => (
          <button
            key={`suggestion-${s.replace(/\s+/g, '-').toLowerCase()}`}
            onClick={() => onSelect(s)}
            className="flex-shrink-0 px-3.5 py-2 rounded-2xl border border-border bg-card text-foreground text-xs font-medium transition-all duration-200 hover:border-primary hover:text-primary hover:bg-primary/5 active:scale-95 whitespace-nowrap"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}